import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import moment from 'moment'
Vue.use(iView);

import net from './utils/net';
import lfy from './utils/lfy';
Vue.prototype.$net = net;
Vue.prototype.$lfy = lfy;

/**
 * 全局格式化时间
 */
Vue.prototype.$moment = (date,format)=>{
  date = date || new Date(),
  format = format || "YYYY-MM-DD HH:mm";
  return moment(date).format(format)
};
/**
 * 全局格式化日期
 */
Vue.prototype.$momentDate = (date,format)=>{
  date = date || new Date(),
  format = format || "YYYY-MM-DD";
  return moment(date).format(format)
};


Vue.config.productionTip = false



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
